import { useEffect } from 'react';

export function useApprovalFlush(
  setFlushFn: (fn: () => Promise<void>) => void,
  hasPendingChangesRef: React.MutableRefObject<boolean>,
  saveContentChanges: () => Promise<void>
) {
  useEffect(() => {
    setFlushFn(async () => {
      if (hasPendingChangesRef.current) {
        await saveContentChanges();
      }
    });
  }, [setFlushFn, hasPendingChangesRef, saveContentChanges]);
}
